var _path, _path2, _g, _path3, _path4, _path5, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBlockTrees(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 45C66.5 61.0163 53.5163 74 37.5 74C21.4837 74 8.5 61.0163 8.5 45C8.5 28.9837 21.4837 16 37.5 16C53.5163 16 66.5 28.9837 66.5 45Z",
    stroke: "#364052",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_43_719",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 15,
    width: 61,
    height: 60
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 75C54.0685 75 67.5 61.5685 67.5 45C67.5 28.4315 54.0685 15 37.5 15C20.9315 15 7.5 28.4315 7.5 45C7.5 61.5685 20.9315 75 37.5 75Z",
    fill: "#364052"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_43_719)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.01953 55.418H67.7275V76.268H6.07853L6.01953 55.418Z",
    fill: "#364052"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2 51.498C56.2 51.498 57.59 35.357 57.424 34.838C57.258 34.325 46 25.609 46 25.609C46 25.609 48.87 27.674 51.795 29.681C51.851 29.739 50.635 24.579 50.635 24.635C50.801 25.208 52.235 29.968 52.291 30.024C55.161 31.972 57.921 33.693 58.03 33.236C58.086 32.949 58.14 30.714 58.196 27.961C58.252 25.896 58.252 23.546 58.306 21.425C58.306 21.367 54.333 16.724 54.333 16.665C54.333 16.607 58.306 21.139 58.306 21.08C58.362 17.754 58.362 15.001 58.362 15.001C58.362 15.001 58.528 20.047 58.748 24.635C58.748 24.749 64.158 16.32 64.599 15.575C64.655 15.46 58.748 25.208 58.748 25.381C58.968 29.108 59.19 32.321 59.466 32.321C59.852 32.26 71 23.831 71 23.831C71.002 23.829 59.798 33.176 59.798 34.495C59.798 35.815 60.279 51.112 60.279 51.112C60.279 51.112 58.494 53 58.03 53C57.566 53 56.2 51.498 56.2 51.498Z",
    fill: "#364052"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.093 17.358C67.743 17.358 67.453 17.417 67.163 17.417C67.047 12.747 63.215 9 58.455 9C53.635 9 49.747 12.861 49.747 17.646C49.747 18.511 49.862 19.376 50.096 20.125H49.98C46.672 20.125 44 22.777 44 26.062C44 29.348 46.671 32 49.98 32C53.289 32 55.96 29.348 55.96 26.062V25.948C56.772 26.178 57.586 26.294 58.457 26.294C59.4673 26.3001 60.4705 26.125 61.419 25.777C62.113 28.771 64.841 31.018 68.093 31.018C71.925 31.018 75 27.963 75 24.16C75 20.355 71.923 17.358 68.093 17.358Z",
    fill: "#364052"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_43_719",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 15,
    width: 61,
    height: 60
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 75C54.0685 75 67.5 61.5685 67.5 45C67.5 28.4315 54.0685 15 37.5 15C20.9315 15 7.5 28.4315 7.5 45C7.5 61.5685 20.9315 75 37.5 75Z",
    fill: "#364052"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_43_719)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.575 104.954C41.46 116.588 28.636 124.352 14 124.352C-8.368 124.352 -26.5 106.219 -26.5 83.852C-26.5 61.484 -8.368 43.352 14 43.352C19.32 43.352 24.4 44.378 29.054 46.242C31.174 43.364 34.559 41.5 38.375 41.5C42.563 41.5 46.235 43.746 48.281 47.114C49.1983 46.3914 50.3323 45.9989 51.5 46C54.29 46 56.571 48.198 56.74 50.974C57.608 50.894 58.486 50.852 59.375 50.852C74.908 50.852 87.5 63.444 87.5 78.977C87.5 94.51 74.908 107.102 59.375 107.102C55.6684 107.107 51.9976 106.377 48.575 104.954ZM42.467 56.5H26.682L2.172 60.79L-2.841 82.214H31.434C31.3111 81.1394 31.2497 80.0586 31.25 78.977C31.25 69.79 35.654 61.633 42.467 56.5Z",
    fill: "#364052"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBlockTrees);
export default __webpack_public_path__ + "static/media/ic-block-trees.3a1e2724299e2885b3f1aea439fc8021.svg";
export { ForwardRef as ReactComponent };